import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { LogService } from '../api/services';
import { State } from '../store/interfaces';
import {
  loadLogErrorAction,
  loadLogRequestAction,
  loadLogSuccessAction,
} from '../store/reducers/log';
import { Dict } from '../models';

export const useLog = (logService: LogService) => {
  const log = useSelector((state: State) => state.log);

  const [updating, setUpdating] = useState<boolean>(false);
  const [updateError, setUpdateError] = useState<string | undefined>();
  const dispatch = useDispatch();

  const loadAllLog = async (
    data: { page: number; leadId?: string } & Dict,
    onSuccess?: () => void
  ) => {
    if (log.isLoading) {
      return;
    }
    dispatch(loadLogRequestAction());
    try {
      const response = await logService.getAllLogs(data);
      if (onSuccess) {
        onSuccess?.();
      }
      return dispatch(loadLogSuccessAction(response));
    } catch (error) {
      return dispatch(loadLogErrorAction());
    }
  };

  return {
    loadAllLog,
  };
};
